import { render, staticRenderFns } from "./SearchDocumentations.vue?vue&type=template&id=5641dd4c&"
import script from "./SearchDocumentations.vue?vue&type=script&lang=js&"
export * from "./SearchDocumentations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports